import { ChakraProvider, defaultSystem, Box, VStack } from '@chakra-ui/react';
import { useEffect } from 'react';
import posthog from 'posthog-js';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import ChatInterface from './components/ChatInterface';
import { checkVersionAndClear } from './utils/versionUtils';
import { tracking } from './utils/tracking';

function App() {
  useEffect(() => {
    // Check for version updates and clear data if needed
    const performVersionCheck = async () => {
      try {
        await checkVersionAndClear();
      } catch (error) {
        // Silent error handling
      }
    };

    // Initialize PostHog at runtime if not already initialized
    const initializePostHog = () => {
      // Check if PostHog is already initialized (from build-time init)
      if (window.posthog && window.posthog.__loaded) {
        console.log('PostHog already initialized at build time');
        return;
      }

      // Simple hardcoded initialization - PostHog keys are meant to be public
      console.log('Initializing PostHog at runtime with hardcoded key');
      posthog.init("phc_jyZ3nBsV5kPlVsKqvLZK9Pl6omFnebvPjbHictCSOas", {
        api_host: "https://us.i.posthog.com",
        person_profiles: 'identified_only',
        capture_pageview: false
      });
    };

    const initialize = async () => {
      await performVersionCheck();
      initializePostHog();
      
      // Track app load (works regardless of when PostHog initializes)
      tracking.appLoaded();
      tracking.pageViewed('home');
    };

    initialize();
  }, []);

  return (
    <ChakraProvider value={defaultSystem}>
      <Box minH="100vh" className="bg-pink-950">
        <Header />
        <Box pt="70px">
          <VStack spacing={0} align="stretch">
            <HeroSection />
            <ChatInterface />
          </VStack>
        </Box>
      </Box>
    </ChakraProvider>
  );
}

export default App;
